import { useEffect, useState } from "react";
import { PlanSwitcherProps } from "./planSwitcher.model";
import { useAuth } from "@/features/Auth/lib/useAuth";
import { usePlan } from "@/entities/Plan";
import Tooltip from "@/shared/components/organism/Tooltip/Tooltip";
import { Button } from "@/shared/components/common/Button/Button";

function PlanSwitcher({ showOwnPlans, showAssignedPlans, showAllPlans = false, value, onChange }: PlanSwitcherProps) {
  const [opportunityPlanData, setOpportunityPlanData] = useState({plan: 0, create: 0})
  const [profitPlanData, setProfitPlanData] = useState({plan: 0, create: 0})

  const { myPlans, planTypes } = usePlan();
  const { user } = useAuth();
  const isDir = user?.bx.bx_user.bx_id === 14

  useEffect(() => {
    if(myPlans && planTypes && user){
      const id = user.bx.bx_user.bx_id;
      const opportunityPlanTypes = planTypes.filter(t => t.code.includes('OPPORTUNITY'))
      const profitPlanTypes = planTypes.filter(t => t.code.includes('PROFIT'))

      setOpportunityPlanData({
        plan: myPlans
          .filter(p => 
            p.user_id === id && 
            opportunityPlanTypes.some(ot => ot.id === p.plan_type_id)
          )
          .reduce((sum, plan) => sum + (plan.target_value || 0), 0),
          
        create: myPlans
          .filter(p => 
            p.created_by === id && 
            opportunityPlanTypes.some(ot => ot.id === p.plan_type_id)
          )
          .reduce((sum, plan) => sum + (plan.target_value || 0), 0),
      });

      setProfitPlanData({
        plan: myPlans
          .filter(p => 
            p.user_id === id && 
            profitPlanTypes.some(ot => ot.id === p.plan_type_id)
          )
          .reduce((sum, plan) => sum + (plan.target_value || 0), 0),
          
        create: myPlans
          .filter(p => 
            p.created_by === id && 
            profitPlanTypes.some(ot => ot.id === p.plan_type_id)
          )
          .reduce((sum, plan) => sum + (plan.target_value || 0), 0),
      });
    }
  },[myPlans, planTypes, user])

  const tooltipText = `
    ОБОРОТ:
    Поставленный план: ${opportunityPlanData.plan.toLocaleString()}
    Распределенный план: ${opportunityPlanData.create.toLocaleString()}
    Распределенно: ${opportunityPlanData.plan > 0 
      ? `${((opportunityPlanData.create / opportunityPlanData.plan) * 100).toFixed(1)}%` 
      : '0%'}

    ПРИБЫЛЬ:
    Поставленный план: ${profitPlanData.plan.toLocaleString()}
    Распределенный план: ${profitPlanData.create.toLocaleString()}
    Распределенно: ${profitPlanData.plan > 0 
      ? `${((profitPlanData.create / profitPlanData.plan) * 100).toFixed(1)}%` 
      : '0%'}
  `;

  return (
    <div style={{display: 'flex', gap: 16, alignItems: 'center'}}>
      {!isDir && !showAllPlans && (
        <Tooltip 
          text={tooltipText}
          position="cursor"
        >
          Распределение планов
        </Tooltip>
      )}

      {!isDir && !showAllPlans && (
        <Button
          onClick={() => onChange('own')}
        >
          Собственные планы
        </Button>
      )}
      <Button
        onClick={() => onChange('assigned')}
      >
        {showAllPlans ? 'Все планы' : 'Планы, поставленные мной'}
      </Button>
    </div>
  )
}

export default PlanSwitcher
